<template>
    <AboutUsSection />
    <CompanyCultureSection />
    <OurExpertsSection />
</template>

<script>
import AboutUsSection from '../Por_que/AboutUsSection.vue';
import CompanyCultureSection from '../Por_que/CompanyCultureSection.vue';
import OurExpertsSection from '../Por_que/OurExpertsSection.vue';

export default {
  name: 'AboutIndex',
  components: {
    AboutUsSection,
    CompanyCultureSection,
    OurExpertsSection
  }
}
</script>